export const payForms = {
  op: '_%pago online%_',
  paypal: '_%payPal%_',
  htl: '_%pago en el hotel%_',
  htlng: '_%pago en el hotel sin garantía%_',
  ccg: '_%crédito sin garantía%_',
  ccng: '_%crédito con garantía%_'
};
